<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg text-white cursor-pointer"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
        @click="iconPickerVisible = true"
      >
        <icon v-if="this.module.settings.icon" :name="this.module.settings.icon" class="text-white" />
      </div>
      <h3 class="text-2xl font-medium ml-4">Knowledge Hub</h3>
    </div>

    <input type="text" placeholder="Title" class="input-sm w-full mb-4" v-model="module.title" required>
    <textarea rows="3" class="input-sm w-full mb-4" placeholder="Description" v-model="module.settings.description" required></textarea>

    <input type="text" placeholder="Call to Action" class="input-sm w-full mb-4" v-model="module.settings.cta" required>

    <modal v-if="iconPickerVisible" :scrollY="false">
      <icon-picker />
    </modal>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import IconPicker from '@/components/IconPicker'

export default {
  components: { IconPicker },

  props: ['module'],

  data () {
    return {
      iconPickerVisible: false
    }
  },

  methods: {
    saved (data) {
      if (this.iconPickerVisible) {
        this.iconPickerVisible = false
        this.$set(this.module.settings, 'icon', data.icon)
        this.$set(this.module.settings, 'icon_color', data.color)
      }
    },

    cancelled () {
      this.iconPickerVisible = false
    }
  },

  created () {
    EventBus.$on('icon-picker:cancel', this.cancelled)
    EventBus.$on('icon-picker:saved', this.saved)
  },

  beforeDestroy () {
    EventBus.$off('icon-picker:cancel', this.cancelled)
    EventBus.$off('icon-picker:saved', this.saved)
  }
}
</script>
